import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { fetchAPI } from '../../../helpers'

// TODO: import { fetchAPI } from '@helpers'

type BaseAppProps = {
  updated_at: string
  dependencies: {
    api: {
      version: string
    }
  }
}

export default function ApiVersion() {
  const { t } = useTranslation('common')
  const { data, isLoading } = useSWR(`${process.env.API_URL}/`, fetchAPI<BaseAppProps>, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  })

  if (isLoading) {
    return t('version.loading')
  }

  if (!data) {
    return null
  }

  return t('version.prefix', { version: data.dependencies.api.version })
}
